
import { VisioMapApp } from "./visiomap";
import { type Floor } from "../app";
import type { VGPOI } from "types/visioweb/poi";

export class PoiTool {

  private app: VisioMapApp;

  constructor (app: VisioMapApp) {
    this.app =  app;
  }

  private labeled_floors = new Set<string>();

  setLabelsForFloor(floor: Floor) {
    const { impl_layer } = this.app;
    const { font_family, zoom_scale_factor } = impl_layer.config.extra;
    
    // Only once per floor
    if (this.labeled_floors.has(floor.id)) { return; }
    this.labeled_floors.add(floor.id);

    const floor_pois = this.app.poi_data.list.filter(x => {
      const vg_poi = this.getVgPOI(x.id);
      return vg_poi?.options().floor == floor.id;
    });

    const ids_unused = floor_pois.reduce((ids: Set<string>, poi) => {
      if (poi.type != 'store') return ids;
      const { id, label: name } = poi;
      const vg_poi = this.getVgPOI(id);
      if (!vg_poi) return ids;

      try {

        impl_layer.essential.content.setPlaceName({
          id,
          name,
          parameters: {
            family: font_family,
            zoomScaleFactor: zoom_scale_factor,
            zoomScaleVisible: true
          }
        });
        
        ids.delete(id);

      } catch (error) {
        console.log(`Failed setting label "${name}" for`, poi);
        console.warn(error);
      }
      return ids;
    }, new Set(floor_pois.map(x => x.id)));

    ids_unused.forEach((id) => impl_layer.essential.content.setPlaceName({ id, name: '' }));
  }

  checkLabelsForAllFloors(floors: any) {
    floors.map((floor: Floor) => this.setLabelsForFloor(floor));
  }

  getVgPOI(id: string): VGPOI {
    const [poi] = this.app.impl_layer.essential._mapviewer.getPOI(id) || [];
    return poi;
  }

  static splitCode(space_code = '') {
    return space_code.split(/\s*,\s*/);
  }
}
